import React from 'react';
import "./Header.css";
import Navbar from '../Navbar/Navbar';
import {Link} from "react-router-dom";

const Header = () => {
  return (
    <div className='header flex flex-col' id = "header">
        <Navbar />

        <div className='container flex'>
            <div className='header-content'>
                <h2 className='text-uppercase text-white op-07 fw-6 ls-2'>web design, branding, software development</h2>
                <h1 className='text-white fw-6 header-title'>Hello, We are <span className='text-brown'>Web & Software Solutions Company</span> creating websites & SW applications</h1>
                <div className='btn-groups flex'>
                  <Link to="/contact" className='btn-item bg-dark fw-4 ls-2'>Contact Us</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Header